exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-podziekowanie-js": () => import("./../../../src/pages/Podziekowanie.js" /* webpackChunkName: "component---src-pages-podziekowanie-js" */)
}

